/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_SwedishInputs */



/**
* | output |
* | --- |
* | "Swedish" |
*
* @param {Speechmatics_Target_Language_SwedishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_swedish = /** @type {((inputs?: Speechmatics_Target_Language_SwedishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_SwedishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suedois")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schwedisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("svedese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("шведский")
	if (locale === "es") return /** @type {LocalizedString} */ ("sueco")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("瑞典")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スウェーデン語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वीडिश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("sueco")
	return /** @type {LocalizedString} */ ("Swedish")
});